import axios from "axios";

import config from "./config";

let axiosObject;

axiosObject = axios.create({
  baseURL: config.API_BASE_URL,
});

export default axiosObject;
